import { jsx } from 'react/jsx-runtime';
import { Rectangle } from '../elements.js';

/**
 * Text
 * ====
 * Creates a skeleton that looks like a line of text with a seemingly random width.
 *
 * -----------------------------------------------------------------------------
 *
 * @param currentLine - Current line (usually "i" in a map function)
 * @param isLastLine  - Should be true if this is the last line in a paragraph
 * @param isOnlyLine -  Should be true rendering only one line
 *
 * -----------------------------------------------------------------------------
 *
 * @example
 * ```
 *   <Skeleton.Text currentLine={3} isLastLine />
 * ```
 */
var Text = function Text(_ref) {
  var isOnlyLine = _ref.isOnlyLine,
    _ref$currentLine = _ref.currentLine,
    currentLine = _ref$currentLine === undefined ? 0 : _ref$currentLine,
    isLastLine = _ref.isLastLine;
  // Prevent having to using Math.random (changing lengths on rerender)
  var lengths = [90, 99, 85, 100, 78, 96, 90, 93, 86, 68];
  var width = '';
  if (isOnlyLine) {
    // If there is only one line
    width = lengths[currentLine] + "%";
  } else if (isLastLine) {
    // The last line of a paragraph
    width = '30%';
  } else {
    // Every line in a paragraph, except for the last
    width = lengths[currentLine] + "%";
  }
  return jsx(Rectangle, {
    role: "row",
    className: "cogs-v10 cogs-skeleton cogs-skeleton__rectangle",
    width: width
  });
};

export { Text };
